import {
  SeuApiConverter,
  SeuConfigInputItem,
  SeuConfigInputValueType,
} from '@seu-types';
import { isNil } from 'lodash-es';
import { SeuApiInput } from '../api';

export const configInputConverter: SeuApiConverter<
  SeuConfigInputItem,
  SeuApiInput
> = {
  fromApi: (input) => {
    let value: string | string[] | number | boolean | undefined;
    if (
      typeof input.unitValue.value === 'number' ||
      typeof input.unitValue.value === 'string' ||
      typeof input.unitValue.value === 'boolean' ||
      Array.isArray(input.unitValue.value)
    ) {
      value = input.unitValue.value;
    }

    if (isNil(value)) {
      value = '';
    }

    const valueType = input.valueType as SeuConfigInputValueType;

    return {
      ...input,
      valueType,
      unitValue: {
        ...input.unitValue,
        value,
      },
    };
  },
  toApi: (input) => {
    return {
      ...input,
      excludeFromChangelog: input.excludeFromChangelog ?? false,
      unitValue: {
        ...input.unitValue,
        unit: input.unitValue.unit ?? undefined,
      },
    };
  },
};
